import { Box, Divider, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface PropertyListItemProps {
  align?: string;
  children?: ReactNode;
  label: string;
  value?: string;
  width?: number | string;
  divider?: boolean;
}

export const PropertyListItem: FC<PropertyListItemProps> = props => {
  const { align, children, value, label, divider } = props;

  const isVertical = align === 'vertical';

  if (isVertical) {
    return (
      <>
        <Box sx={{ py: 1.5, px: 3 }}>
          <Typography color="textPrimary" variant="subtitle2">
            {label}
          </Typography>
          <Box sx={{ mt: 0.5 }}>
            {children || (
              <Typography color="textSecondary" variant="body2">
                {value}
              </Typography>
            )}
          </Box>
        </Box>
        {divider && <Divider />}
      </>
    );
  }

  return (
    <>
      <Box sx={{ py: 1.5, px: 3, display: 'flex', alignItems: 'center' }}>
        <Typography color="textPrimary" variant="subtitle2">
          {label}
        </Typography>
      </Box>
      <Box sx={{ py: 1.5, pr: 3, display: 'flex', alignItems: 'center' }}>
        {children || (
          <Typography color="textSecondary" variant="body2" sx={{ wordBreak: 'break-word' }}>
            {value}
          </Typography>
        )}
      </Box>
      {divider && (
        <Box
          sx={{
            gridColumn: '1 / -1',
          }}>
          <Divider />
        </Box>
      )}
    </>
  );
};
